import * as React from 'react';

import { GridMonthsProps } from '../../components/grid/months';
import GridMonth from '../../components/grid/month';
import LoadMoreBase from '../month-selection/load-more';

const GridMonthsView: React.StatelessComponent<GridMonthsProps> = props => {
    return (
        <section className="ace-cal-grid">
            <h2 className="visually-hidden">{props.text.gridViewHeading}</h2>
            <ul className="ace-cal-grid-months test1">
                {
                    props.monthsData.map(monthData => <GridMonth key={`${monthData.monthMoment.month()}${monthData.monthMoment.year()}`} monthData={monthData} />)
                }
            </ul>
            <ul className="ace-cal-grid-months test2">
                {
                    props.nextmonthsData != null && props.nextmonthsData.length > 0 ?
                        props.nextmonthsData.map(monthData => <GridMonth key={`${monthData.monthMoment.month()}${monthData.monthMoment.year()}`} monthData={monthData} />)
                        : null
                }
            </ul>
            <LoadMoreBase />
        </section>
    )
}

export default GridMonthsView;